/**
 * DetoxTeaBlend — Wishlist + Compare
 * Native, dependency-free, localStorage-backed. No app, no external libraries.
 * Stores stable product handles only (never price/stock data).
 * Fails gracefully if localStorage is unavailable or corrupt — never breaks the
 * storefront or other localStorage systems (cart, localization popup, etc.).
 */
(function () {
  'use strict';

  var KEY_WISH = 'dtb_wishlist';
  var KEY_CMP = 'dtb_compare';

  var cfgEl = document.getElementById('dtb-config');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var COMPARE_MAX = CFG.compareMax || 4;

  function decodeEntities(s) {
    if (typeof s !== 'string' || s.indexOf('&') === -1) return s;
    var el = document.createElement('textarea');
    el.innerHTML = s;
    return el.value;
  }
  var i18nEl = document.getElementById('dtb-i18n');
  var T = {};
  try {
    T = i18nEl ? JSON.parse(i18nEl.textContent) : {};
    for (var _k in T) { if (Object.prototype.hasOwnProperty.call(T, _k)) T[_k] = decodeEntities(T[_k]); }
  } catch (e) { T = {}; }
  function t(k, fallback) { return (T && typeof T[k] === 'string') ? T[k] : (fallback || k); }

  /* ---------- safe storage ---------- */
  function lsAvailable() {
    try {
      var k = '__dtb_test__';
      window.localStorage.setItem(k, '1');
      window.localStorage.removeItem(k);
      return true;
    } catch (e) { return false; }
  }
  var HAS_LS = lsAvailable();

  function read(key) {
    if (!HAS_LS) return [];
    var raw;
    try { raw = window.localStorage.getItem(key); } catch (e) { return []; }
    if (!raw) return [];
    var val;
    try { val = JSON.parse(raw); } catch (e) {
      // corrupt — reset ONLY this feature's key
      try { window.localStorage.removeItem(key); } catch (e2) {}
      return [];
    }
    if (!Array.isArray(val)) {
      try { window.localStorage.removeItem(key); } catch (e2) {}
      return [];
    }
    // keep only non-empty strings, de-duplicated
    var out = [];
    for (var i = 0; i < val.length; i++) {
      var h = val[i];
      if (typeof h === 'string' && h && out.indexOf(h) === -1) out.push(h);
    }
    return out;
  }
  function write(key, arr) {
    if (!HAS_LS) return;
    try { window.localStorage.setItem(key, JSON.stringify(arr)); } catch (e) {}
  }

  var state = { wishlist: read(KEY_WISH), compare: read(KEY_CMP) };

  function has(type, handle) { return state[type].indexOf(handle) !== -1; }

  function toggle(type, handle) {
    var arr = state[type];
    var idx = arr.indexOf(handle);
    if (idx === -1) {
      if (type === 'compare' && arr.length >= COMPARE_MAX) {
        toast((t('compare_limit_reached', 'You can compare up to ~LIMIT~ products.')).replace('~LIMIT~', COMPARE_MAX));
        return false;
      }
      arr.push(handle);
    } else {
      arr.splice(idx, 1);
    }
    write(type === 'wishlist' ? KEY_WISH : KEY_CMP, arr);
    syncControls();
    renderIndicator();
    renderPages();
    return true;
  }

  /* ---------- toast ---------- */
  var toastEl = document.getElementById('dtb-toast');
  var toastTimer = null;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
      setTimeout(function () { if (toastEl) toastEl.hidden = true; }, 300);
    }, 3200);
  }

  /* ---------- control state sync ---------- */
  function syncControls() {
    var btns = document.querySelectorAll('[data-dtb-action]');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      var type = b.getAttribute('data-dtb-action');
      var handle = b.getAttribute('data-handle');
      if (!handle || (type !== 'wishlist' && type !== 'compare')) continue;
      var active = has(type, handle);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
      b.classList.toggle('is-active', active);
      var lbl = active ? b.getAttribute('data-label-remove') : b.getAttribute('data-label-add');
      if (lbl) b.setAttribute('aria-label', lbl);
      var txt = b.querySelector('.dtb-ctl__txt');
      if (txt && b.getAttribute('data-text-toggle') === 'true') {
        txt.textContent = active ? (b.getAttribute('data-label-remove') || txt.textContent) : (b.getAttribute('data-label-add') || txt.textContent);
      }
    }
  }

  /* ---------- floating indicator ---------- */
  var indicatorEl = null;
  function renderIndicator() {
    var wc = state.wishlist.length;
    var cc = state.compare.length;
    if (wc === 0 && cc === 0) {
      if (indicatorEl) indicatorEl.hidden = true;
      return;
    }
    if (!indicatorEl) {
      indicatorEl = document.createElement('div');
      indicatorEl.className = 'dtb-fab';
      indicatorEl.setAttribute('aria-label', t('lists_label', 'Saved lists'));
      document.body.appendChild(indicatorEl);
    }
    indicatorEl.hidden = false;
    var wishUrl = CFG.wishlistUrl || '/pages/wishlist';
    var cmpUrl = CFG.compareUrl || '/pages/compare';
    indicatorEl.innerHTML =
      (wc > 0 ? '<a class="dtb-fab__chip" href="' + esc(wishUrl) + '"><span class="dtb-fab__ico" aria-hidden="true">' + HEART + '</span><span class="dtb-fab__n">' + wc + '</span><span class="visually-hidden">' + esc(t('wishlist_title', 'Wishlist')) + '</span></a>' : '') +
      (cc > 0 ? '<a class="dtb-fab__chip" href="' + esc(cmpUrl) + '"><span class="dtb-fab__ico" aria-hidden="true">' + SCALES + '</span><span class="dtb-fab__n">' + cc + '</span><span class="visually-hidden">' + esc(t('compare_title', 'Compare')) + '</span></a>' : '');
  }

  /* ---------- add to cart (native Shopify AJAX cart) ---------- */
  function addToCart(variantId, btn) {
    if (!variantId) return;
    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      toast(t('added_to_cart', 'Added to cart'));
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); } catch (e) {}
      var d = document.querySelector('cart-drawer, theme-drawer#cart-drawer');
      if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
    }).catch(function () {
      toast(t('cart_error', 'Sorry, that could not be added.'));
    }).then(function () {
      if (btn) btn.removeAttribute('aria-busy');
    });
  }

  /* ---------- catalog + page rendering ---------- */
  var catalog = null;
  function getCatalog() {
    if (catalog) return catalog;
    var el = document.getElementById('dtb-catalog');
    if (!el) return null;
    try {
      var arr = JSON.parse(el.textContent);
      catalog = {};
      for (var i = 0; i < arr.length; i++) { if (arr[i] && arr[i].handle) catalog[arr[i].handle] = arr[i]; }
    } catch (e) { catalog = {}; }
    return catalog;
  }

  function savePctLabel(pct) {
    var tpl = CFG.savePercentTpl || 'Save ~PCT~%';
    return tpl.replace('~PCT~', pct);
  }

  function priceHtml(p) {
    var html = '';
    if (p.compareAt) {
      html += '<span class="dtb-price"><s class="dtb-price__was">' + esc(p.compareAt) + '</s> <span class="dtb-price__now">' + esc(p.price) + '</span></span>';
    } else {
      html += '<span class="dtb-price"><span class="dtb-price__now">' + esc(p.price) + '</span></span>';
    }
    if (p.savePct && p.savePct > 0) {
      html += ' <span class="dtb-save">' + esc(savePctLabel(p.savePct)) + '</span>';
    }
    return html;
  }

  function cardActions(p) {
    var buy = p.available && p.variantId
      ? '<button type="button" class="dtb-btn dtb-btn--primary" data-dtb-addcart data-variant-id="' + esc(String(p.variantId)) + '">' + esc(t('add_to_cart', 'Add to cart')) + '</button>'
      : '<span class="dtb-btn dtb-btn--disabled" aria-disabled="true">' + esc(t('out_of_stock', 'Out of stock')) + '</span>';
    return buy;
  }

  function renderWishlistPage() {
    var grid = document.getElementById('dtb-wishlist-grid');
    if (!grid) return;
    var page = grid.closest('[data-dtb-page]');
    var emptyEl = page ? page.querySelector('[data-dtb-empty]') : null;
    var countEl = page ? page.querySelector('[data-dtb-count]') : null;
    var cat = getCatalog() || {};
    var items = state.wishlist.map(function (h) { return cat[h]; }).filter(Boolean);

    if (countEl) {
      if (items.length) {
        countEl.hidden = false;
        countEl.textContent = plural('wishlist_count', items.length);
      } else { countEl.hidden = true; }
    }
    if (!items.length) {
      grid.hidden = true; grid.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    grid.hidden = false;
    grid.innerHTML = items.map(function (p) {
      return '<article class="dtb-card">' +
        '<a class="dtb-card__media" href="' + esc(p.url) + '">' +
          (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="400" height="400">' : '') +
        '</a>' +
        '<div class="dtb-card__body">' +
          '<a class="dtb-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="dtb-card__price">' + priceHtml(p) + '</div>' +
          '<div class="dtb-card__actions">' +
            cardActions(p) +
            '<button type="button" class="dtb-btn dtb-btn--ghost" data-dtb-action="wishlist" data-handle="' + esc(p.handle) + '" aria-pressed="true">' + esc(t('remove', 'Remove')) + '</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }).join('');
  }

  function renderComparePage() {
    var host = document.getElementById('dtb-compare-grid');
    if (!host) return;
    var page = host.closest('[data-dtb-page]');
    var emptyEl = page ? page.querySelector('[data-dtb-empty]') : null;
    var countEl = page ? page.querySelector('[data-dtb-count]') : null;
    var cat = getCatalog() || {};
    var items = state.compare.map(function (h) { return cat[h]; }).filter(Boolean);

    if (countEl) {
      if (items.length) { countEl.hidden = false; countEl.textContent = plural('compare_count', items.length); }
      else { countEl.hidden = true; }
    }
    if (!items.length) {
      host.hidden = true; host.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    host.hidden = false;

    var rows = [
      { key: 'img', label: '', cell: function (p) { return '<a href="' + esc(p.url) + '">' + (p.img ? '<img loading="lazy" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="240" height="240">' : '') + '</a>'; } },
      { key: 'name', label: t('compare_col_name', 'Product'), cell: function (p) { return '<a class="dtb-cmp__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'; } },
      { key: 'type', label: t('compare_col_type', 'Type'), cell: function (p) { return esc(p.type || '—'); } },
      { key: 'price', label: t('compare_col_price', 'Price'), cell: function (p) { return priceHtml(p); } },
      { key: 'avail', label: t('compare_col_availability', 'Availability'), cell: function (p) { return p.available ? esc(t('in_stock', 'In stock')) : esc(t('out_of_stock', 'Out of stock')); } },
      { key: 'act', label: '', cell: function (p) {
        return '<div class="dtb-cmp__actions">' + cardActions(p) +
          '<button type="button" class="dtb-btn dtb-btn--ghost" data-dtb-action="compare" data-handle="' + esc(p.handle) + '" aria-pressed="true">' + esc(t('remove', 'Remove')) + '</button>' +
          '<a class="dtb-btn dtb-btn--link" href="' + esc(p.url) + '">' + esc(t('view_product', 'View product')) + '</a></div>'; } }
    ];

    var thead = '<tr><th scope="col"><span class="visually-hidden">' + esc(t('compare_col_attribute', 'Attribute')) + '</span></th>' +
      items.map(function (p) { return '<th scope="col">' + esc(p.title) + '</th>'; }).join('') + '</tr>';
    var tbody = rows.map(function (r) {
      return '<tr><th scope="row">' + esc(r.label) + '</th>' +
        items.map(function (p) { return '<td>' + r.cell(p) + '</td>'; }).join('') + '</tr>';
    }).join('');

    host.innerHTML = '<div class="dtb-cmp__scroll"><table class="dtb-cmp__table"><thead>' + thead + '</thead><tbody>' + tbody + '</tbody></table></div>';
  }

  function renderPages() { renderWishlistPage(); renderComparePage(); }

  function plural(baseKey, n) {
    var one = t(baseKey + '_one', '');
    var other = t(baseKey + '_other', '');
    var s = (n === 1 && one) ? one : (other || one || (n + ''));
    return s.replace('{{ count }}', n).replace('{{ count }}', n);
  }

  /* ---------- PDP injection ---------- */
  function injectPdp() {
    var tmpl = (window.Theme && Theme.template && Theme.template.name) || '';
    if (tmpl !== 'product') return;
    var el = document.getElementById('dtb-current-product');
    if (!el) return;
    var p;
    try { p = JSON.parse(el.textContent); } catch (e) { return; }
    if (!p || !p.handle || document.querySelector('.dtb-ctl-wrap--pdp')) return;

    var anchor =
      document.querySelector('.product-details [ref="priceContainer"]') ||
      document.querySelector('.product-information [ref="priceContainer"]') ||
      document.querySelector('product-price') ||
      document.querySelector('.product-information h1, .product-details h1');
    if (!anchor) return;

    var wrap = document.createElement('div');
    wrap.className = 'dtb-ctl-wrap dtb-ctl-wrap--pdp';
    wrap.setAttribute('data-dtb-controls', '');
    wrap.innerHTML =
      ctlBtn('wishlist', p.handle, t('add_to_wishlist', 'Add to wishlist'), t('remove_from_wishlist', 'Remove from wishlist'), HEART, false) +
      ctlBtn('compare', p.handle, t('add_to_compare', 'Add to compare'), t('remove_from_compare', 'Remove from compare'), SCALES, true);
    var host = anchor.closest('product-price') || anchor;
    if (host && host.parentNode) host.parentNode.insertBefore(wrap, host.nextSibling);
    syncControls();
  }

  function ctlBtn(action, handle, addL, remL, ico, withText) {
    return '<button type="button" class="dtb-ctl dtb-ctl--' + (action === 'wishlist' ? 'wish' : 'cmp') + '"' +
      ' data-dtb-action="' + action + '" data-handle="' + esc(handle) + '" aria-pressed="false"' +
      ' aria-label="' + esc(addL) + '" data-label-add="' + esc(addL) + '" data-label-remove="' + esc(remL) + '"' +
      (withText ? ' data-text-toggle="true"' : '') + '>' +
      '<span class="dtb-ctl__ico" aria-hidden="true">' + ico + '</span>' +
      (withText ? '<span class="dtb-ctl__txt">' + esc(addL) + '</span>' : '') +
      '</button>';
  }

  /* ---------- helpers ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" focusable="false"><path d="M12 20s-7.5-4.6-9.7-9A5.2 5.2 0 0 1 12 5.5 5.2 5.2 0 0 1 21.7 11c-2.2 4.4-9.7 9-9.7 9z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  var SCALES = '<svg viewBox="0 0 24 24" width="17" height="17" focusable="false"><path d="M12 3v16M6 21h12M4.5 8h5L7 14a3 3 0 0 1-5 0zM14.5 8h5L17 14a3 3 0 0 1-5 0zM7 4.5l10-1.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- one delegated listener ---------- */
  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest ? e.target.closest('[data-dtb-action]') : null;
    if (toggleBtn && document.contains(toggleBtn)) {
      e.preventDefault();
      e.stopPropagation();
      var type = toggleBtn.getAttribute('data-dtb-action');
      var handle = toggleBtn.getAttribute('data-handle');
      if (handle && (type === 'wishlist' || type === 'compare')) toggle(type, handle);
      return;
    }
    var cartBtn = e.target.closest ? e.target.closest('[data-dtb-addcart]') : null;
    if (cartBtn && document.contains(cartBtn)) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(cartBtn.getAttribute('data-variant-id'), cartBtn);
    }
  }, true);

  function init() {
    syncControls();
    renderIndicator();
    injectPdp();
    renderPages();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
